import { EAppStatusActions } from '../../actions/appStatus';
import { IAppStatusState } from '../../types/appStatus';
import { TReduxActions } from '../../types/redux';

export const defaultState: IAppStatusState = {
  isLoading: false,
};

export function appStatusReducer(state: IAppStatusState = defaultState, action: TReduxActions): IAppStatusState {
  switch (action.type) {
    case EAppStatusActions.SetLoading:
      return {
        ...state,
        isLoading: action.payload,
      };
    case EAppStatusActions.SetError:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
